import React, { Component } from 'react';
import { Button, Card, Layout, message, Transfer } from 'antd';
import { BackBtn, goBack } from '@comm/BackBtn';
import { queryCustomCompany, querySaveCustomCompany } from '@api/crm/custom';
import { queryOrgCompanyList } from '@api/core/org';

class Add extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      targetKeys: [],
      selectedKeys: [],
    };
  }

  componentWillMount() {
    const { uuid } = this.props.routeParams;
    this.loadData(uuid);
    this.getOrganiztion();
  }

  loadData = () => {
    const context = this;
    const params = {};
    params.customerUuid = this.props.params.uuid;
    queryCustomCompany(params).then(res => {
      if (res.statusCode === 200) {
        const datas = [];
        for (let i = 0; i < res.data.length; i++) {
          datas.push(res.data[i].uuid);
        }
        context.setState({ targetKeys: datas });
      } else {
        message.error(res.message);
      }
    });
  };

  getOrganiztion = () => {
    const context = this;
    const params = {};
    params.type = 1;
    queryOrgCompanyList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({ data: res.data.result });
      } else {
        message.error(res.message);
      }
    });
  };

  save = () => {
    const { uuid } = this.props.params;
    const params = {};
    params.customUuid = uuid;
    params.orgUuids = this.state.targetKeys;
    querySaveCustomCompany(params).then(res => {
      if (res.statusCode === 200) {
        message.success('保存成功');
        goBack();
      } else {
        message.error(res.message);
      }
    });
  };

  handleChange = nextTargetKeys => {
    this.setState({ targetKeys: nextTargetKeys });
  };

  handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({
      selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys],
    });
  };

  render() {
    const { state } = this;
    return (
      <Layout>
        <div style={{ marginBottom: 15 }}>
          <BackBtn />
          <Button icon="save" style={{ marginRight: 10 }} onClick={this.save}>
            保存
          </Button>
        </div>
        <Card>
          <Transfer
            rowKey={record => record.uuid}
            dataSource={state.data}
            listStyle={{ width: 300, height: 400 }}
            titles={['所有公司', '客户公司']}
            targetKeys={state.targetKeys}
            selectedKeys={state.selectedKeys}
            onChange={this.handleChange}
            onSelectChange={this.handleSelectChange}
            render={item => item.name}
            notFoundContent="暂无公司"
          />
        </Card>
      </Layout>
    );
  }
}

export default Add;



// WEBPACK FOOTER //
// ./src/components/custom/base/company/PageAdd.js